import { render, staticRenderFns } from "./CourseWorkingHoursDetailsPage.vue?vue&type=template&id=68d9da37&scoped=true&"
import script from "./CourseWorkingHoursDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./CourseWorkingHoursDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CourseWorkingHoursDetailsPage.vue?vue&type=style&index=0&id=68d9da37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d9da37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VIcon,VRow})
